import { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";
import { useRillContext } from "../../../../rill/RillReact/share/base";
import {
  findDemoAthleteEntry,
  getTestEmail,
} from "../../../../utils/user-helpers";
import { Athlete, MobileAthlete } from "./AthleteListCard";
import DemoAthleteInstructionsCard from "./DemoAthleteInstructionsCard";

const NoAthletesView = () => {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();
  const [selectedAthlete, setSelectedAthlete] = useState(null);

  const {
    activeUser,
    organizationOwner,
    query = {},
    organizationRoleName,
  } = locals;
  const organizationCoach = query.organizationCoach || undefined;
  const { businessName, name, email, webAppTheme } = activeUser;
  const { referAsClients } = activeUser;
  const appName = businessName || name;
  const testEmail = getTestEmail(email);
  const theme = webAppTheme || "dark";
  const role = referAsClients
    ? t("athletes.roleClientLower")
    : t("athletes.roleAthleteLower");
  const roleCapitalized = referAsClients
    ? t("athletes.roleClient")
    : t("athletes.roleAthlete");
  const demoAthlete = findDemoAthleteEntry(activeUser);

  return (
    <main className="athlete-list no-athletes">
      {demoAthlete ? (
        <DemoAthleteInstructionsCard
          activeUser={activeUser}
          dismissible
          className="demo-athlete-instructions-card--in-athlete-list demo-athlete-instructions-card--in-no-athletes-view"
        />
      ) : null}
      {demoAthlete ? (
        <section className="pb-8!">
          <h2 className="athlete-list-title mb-4!">
            Active {referAsClients ? "Clients" : "Athletes"}
          </h2>
          <MobileAthlete
            athlete={demoAthlete}
            activeUser={activeUser}
            selectedAthlete={selectedAthlete}
            handleSelectedAthlete={setSelectedAthlete}
            organizationCoach={organizationCoach}
            organizationRoleName={organizationRoleName}
          />
          <Athlete
            athlete={demoAthlete}
            activeUser={activeUser}
            selectedAthlete={selectedAthlete}
            handleSelectedAthlete={setSelectedAthlete}
            organizationCoach={organizationCoach}
            organizationRoleName={organizationRoleName}
          />
        </section>
      ) : null}
      <div className="no-athletes-cards">
        {!organizationOwner && !activeUser.organizationId && (
          <article className="no-athlete-card">
            <SvgIcon
              src={`/img/new-icons/Training-App-${theme}.svg`}
              alt={t("athletes.noAthletesView.testAppAlt")}
              noFilterOnLight={true}
            />

            <h3>{t("athletes.noAthletesView.trainingApp", { appName })}</h3>

            <p className="p2">
              {t("athletes.noAthletesView.testOwnApp", { role })}{" "}
              <span className="secondary-text text-(--information)">
                {testEmail}
              </span>
            </p>

            <p className="p2 mt-4 w-full">
              {t("athletes.noAthletesView.notCharged")}
            </p>

            <a
              role="button"
              data-button-type="primary"
              href="/coaching-portal/athletes/?modal[type]=test-account"
            >
              {t("athletes.noAthletesView.testYourApp")}
            </a>
          </article>
        )}
        <article className="no-athlete-card">
          <SvgIcon
            noFilterOnLight={true}
            src={`/img/new-icons/Add-Athlete-${theme}.svg`}
            alt={t("athletes.noAthletesView.addUserAlt")}
          />

          <h3 className="card-title">
            {t("athletes.noAthletesView.addFirstRole", {
              role: roleCapitalized,
            })}
          </h3>

          <p className="p2">
            {t("athletes.noAthletesView.addFirstHint", { role })}
          </p>

          <a
            role="button"
            data-button-type="primary"
            href="/coaching-portal/athletes/?modal[type]=invite-athlete"
          >
            {t("athletes.noAthletesView.addFirstCta", { role })}
          </a>
        </article>

        <article className="no-athlete-card">
          <SvgIcon
            noFilterOnLight={true}
            src={`/img/new-icons/MSB-University-${theme}.svg`}
            alt={t("athletes.noAthletesView.bookAlt")}
          />

          <h3 className="card-title">
            {t("athletes.noAthletesView.learnHowToUse")}
          </h3>

          <p className="p2">{t("athletes.noAthletesView.learnDescription")}</p>

          <a
            role="button"
            data-button-type="primary"
            href="/coaching-portal/msb-university"
          >
            {t("athletes.noAthletesView.learnNow")}
          </a>
        </article>
      </div>
    </main>
  );
};

export default NoAthletesView;
